import { TabPanel, TabPanels, Text } from '@chakra-ui/react'
import FirestoreUser from '../../../types/FirestoreUser'
import EditPersonalProfile from '../sections/Personal'
import ProfileAdditionalDetails from '../sections/AdditionalDetails'
import ProfileMedicalHistory from '../sections/MedicalHistory'
import ProfileEnvironmental from '../sections/Environmental'
import ProfileDental from '../sections/Dental'

interface ProfileTabContentProps {
  uid: string
  user: FirestoreUser | null | undefined
  canEditLockedMedicalDates?: boolean
}

const ProfileTabContent = ({
  uid,
  user,
  canEditLockedMedicalDates = false,
}: ProfileTabContentProps) => {
  return (
    <TabPanels>
      <TabPanel>
        {user && (
          <EditPersonalProfile
            uid={uid}
            firestoreUser={user}
            canEditLockedMedicalDates={canEditLockedMedicalDates}
          />
        )}
      </TabPanel>
      <TabPanel>
        {user && <ProfileAdditionalDetails uid={uid} firestoreUser={user} />}
      </TabPanel>
      <TabPanel>
        {user && <ProfileMedicalHistory uid={uid} firestoreUser={user} />}
      </TabPanel>
      <TabPanel>
        {user && <ProfileEnvironmental uid={uid} firestoreUser={user} />}
      </TabPanel>
      <TabPanel>
        {user && <ProfileDental uid={uid} firestoreUser={user} />}
      </TabPanel>
      <TabPanel>
        <Text>Coming soon!</Text>
      </TabPanel>
    </TabPanels>
  )
}

export default ProfileTabContent
